import CachedResourceStore from '@/store/modules/CachedResourceStore'
import { Document } from '@/models/Document'
export default new CachedResourceStore<Document>(Document, {
	namespaced: true
})
